import React, { useState } from "react"
import { Link } from "gatsby"
import { BiChevronLeft } from "react-icons/bi"

const Sidebar = ({ dropdownData, sidebarName }) => {
  const sidebarData = dropdownData.map((item) => item.items)
  const footerLinksData = dropdownData.map((item) => item)
  const [sidebar, setSidebar] = useState(true)
  return (
    <div
      className={`fixed left-0 right-0 z-50 w-screen h-screen overflow-scroll bg-white top-[60px] md:top-[88px] bottom-0 ${sidebar ? "slide-in" : "slide-out"
        }`}
    >
      <div
        className="flex items-center justify-between w-[93%] mx-auto py-5 text-black border-[#00000026] border-b-[1px]"
        onClick={() => {
          setSidebar(false)
        }}
        role="presentation"
      >
        <p className="text-ats font-semibold Figtree-SemiBold tracking-widest ">
          {sidebarName}
        </p>
        <BiChevronLeft fontSize={28} />
      </div>
      <div className="pb-[110px]">
        {sidebarData.map((data) => (
          data?.map((item, index)=>(
          <div
            className="w-screen h-[60px] overflow-scroll mt-2 hover:bg-[#0000000D] flex items-center justify-between px-4 mx-auto ml-0 "
            key={index}
          >
            <Link className="cursor-pointer flex" to={`/${item.page?.slug}` || `/${item.title?.replace(/\s+/g, '-').toLowerCase()}`}>
              <img src={item.icon.file.url} alt={item.icon.title} />
              <div className="flex-1 ml-4">
                <h4 className="text-base font-semibold  text-black capitalize Figtree-SemiBold tracking-atswide">
                  {item.title}
                </h4>
                <p className="text-sm font-normal text-black normal-case leading-normal font-workSans ">
                  {item.description}
                </p>
              </div>
            </Link>
          </div>
          ))
        ))}
          {/*FooterData*/}
        {
          footerLinksData?.map((item, index)=>(
          <div
            className="w-screen h-[60px] overflow-scroll mt-2 hover:bg-[#0000000D] flex items-center justify-between px-4 mx-auto ml-0 "
            key={index}
          >
            <Link className="cursor-pointer flex" to={`/${item.page?.slug}` || `/${item.title?.replace(/\s+/g, '-').toLowerCase()}`}>
            <img src={item?.icon?.file.url} alt={item?.icon?.title} />
              <div className="flex-1 ml-4">
                <h4 className="text-base font-semibold  text-black capitalize Figtree-SemiBold tracking-atswide">
                  {item.title}
                </h4>
                <p className="text-sm font-normal text-black normal-case leading-normal font-workSans ">
                  {item.description}
                </p>
            
              </div>
            </Link>
          </div>
          ))
        }
      </div>
    </div>
  )
}

export default Sidebar
